var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictoSurfaceSol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.335,
    height: 21.438,
    viewBox: "0 0 23.335 21.438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.75;}.b{fill:none;stroke:#2c3852;stroke-width:1.5px;}.c{fill:#2c3852;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M59.332,77.113H72.879v-3.6h5.537V59.953H59.332Z",
    transform: "translate(-55.831 -56.425)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M59.332,0H78.416V1.265H59.332Zm0,0",
    transform: "translate(-55.831)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,59.953H1.265v17.16H0Zm0,0",
    transform: "translate(0 -56.426)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoSurfaceSol);
export default __webpack_public_path__ + "static/media/picto_surface_sol.aac647de.svg";
export { ForwardRef as ReactComponent };